import React, { Component } from 'react'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import BoxButton from '../Layout/BoxButton'

import SelectorInput from '../Shared/SelectorInput'
import GruposPermisos from './GruposPermisos'

import { 
	displayModalCreate,
	updateInputsInModalCreate,
	createOrUpdateUsuarios
} from '../../actions/usuarios'

import { showModalSelector, selectFromSelector } from '../../actions/common'

class ModalCreate extends Component {
	constructor(props) {
		super(props)

        const tabs = [
            { id: 0, caption: 'Grupos y permisos', component: <GruposPermisos /> },
        ]

		this.state = {
			tabs: [...tabs],
			selected: 0,
		}
	}


	handleCloseModal = (e) => {
		const modal = document.getElementById('modalCreate')
		modal.classList.remove('fadeIn')
		modal.classList.add('fadeOut')

		const modalDialog = document.querySelector(`#modalCreate .modal-dialog`)
		modalDialog.classList.remove('zoomIn')
		modalDialog.classList.add('zoomOut')

		setTimeout(() => this.props.displayModalCreate(false, '', ''), 300)
	}

	selectTab = (e, tab) => {
		e.preventDefault()
		this.setState({ selected: tab })
	}

    handleOpenSelectorReportaA = (path) => {
        let columns = [
            { id: 1, caption: 'Identificacion', value: 'username', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'fullname', width: '70%' }
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = path
            payload.value = a
			this.props.selectFromSelector('MODIFICAR_INPUTS_USUARIOS', payload)
        }
        this.props.showModalSelector('Listado de usuarios', columns, '/usuarios/ldap', fn)
    }


	render() {
		const { modalCreate } = this.props
		const { tabs, selected } = this.state
		if (!modalCreate.get('show')) {
			return null
		}

		return(
			<Modal id="modalCreate" show={ true } ZIndex={ 2000 }>
				<form id="form" onSubmit={ e => { e.preventDefault(); this.props.createOrUpdateUsuarios(modalCreate.get('data'), modalCreate.get('mode')) }} noValidate>
					<ModalHeader title={ modalCreate.get('title') } onClose={ (e) => this.handleCloseModal(e) } />
					<ModalButtonStrip>
                        <BoxButton name="floppy-o" disabled={ modalCreate.get('btnDisabled') } title="Guardar" />
					</ModalButtonStrip>
					<ModalBody >
						<div style={{ width: '80vw', height: '70vh' }}>
							<div className="row" style={{ height: '100%' }}>
								<div className="col-md-3">
									<div className="row">
										<div className="col-md-8">
											<div className="form-group">
												<label className="control-label">Nombre de usuario</label>
												<input type="text" className="form-control input-sm" value={ modalCreate.getIn(['data', 'username']) } onChange={ (e) => this.props.updateInputsInModalCreate('username', e.target.value) } disabled={ modalCreate.get('mode') === 'edit' } />
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-12">
											<div className="form-group">
												<label className="control-label">Nombre</label>
												<input type="text" className="form-control input-sm" value={ modalCreate.getIn(['data', 'nombres']) } onChange={ (e) => this.props.updateInputsInModalCreate('nombres', e.target.value) } />
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-12">
											<div className="form-group">
												<label className="control-label">Apellido</label>
												<input type="text" className="form-control input-sm" value={ modalCreate.getIn(['data', 'apellidos']) } onChange={ (e) => this.props.updateInputsInModalCreate('apellidos', e.target.value) } />
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-12">
											<div className="form-group">
												<label className="control-label">Email</label>
												<input type="email" className="form-control input-sm" value={ modalCreate.getIn(['data', 'email']) } onChange={ (e) => this.props.updateInputsInModalCreate('email', e.target.value) } />
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-12">
											<div className="form-group">
												<label className="control-label">Área</label>
												<select className="form-control input-sm" value={ modalCreate.getIn(['data', 'area_id']) }
														onChange={ (e) => this.props.updateInputsInModalCreate('area_id', e.target.value) }>
														<option value={0} disabled>Seleccione área</option>
														{
															modalCreate.get('areas') &&
															modalCreate.get('areas').map(area => <option value={area.get('id')} key={`area${area.get('id')}`}>{area.get('nombre')}</option>)
														}
												</select>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-12">
											<div className="form-group">
												<label className="control-label">Extensión</label>
												<input type="text" className="form-control input-sm" value={ modalCreate.getIn(['data', 'extension']) } onChange={ (e) => this.props.updateInputsInModalCreate('extension', e.target.value) } />
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-4">
											<div className="form-group">
												<label className="control-label">Súper usuario</label>
												<select className="form-control input-sm" value={ modalCreate.getIn(['data', 'es_superusuario']) } onChange={ (e) => this.props.updateInputsInModalCreate('es_superusuario', e.target.value) }>
													<option value={ 0 }>NO</option>
													<option value={ 1 }>SI</option>
												</select>
											</div>
										</div>
										<div className="col-md-4">
											<div className="form-group">
												<label className="control-label">LDAP</label>
												<select className="form-control input-sm" value={ modalCreate.getIn(['data', 'ldap']) } onChange={ (e) => this.props.updateInputsInModalCreate('ldap', e.target.value) } disabled={ modalCreate.get('mode') === 'create' }>
													<option value={ 0 }>NO</option>
													<option value={ 1 }>SI</option>
												</select>
											</div>
										</div>
										<div className="col-md-4">
											<div className="form-group">
												<label className="control-label">Estado</label>
												<select className="form-control input-sm" value={ modalCreate.getIn(['data', 'esta_activo']) } onChange={ (e) => this.props.updateInputsInModalCreate('esta_activo', e.target.value) } disabled={ modalCreate.get('mode') === 'create' }>
													<option value={ 0 }>INACTIVO</option>
													<option value={ 1 }>ACTIVO</option>
												</select>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-12">
											<div className="form-group">
												<label className="control-label">Reporta a</label>
												<SelectorInput value={ modalCreate.getIn(['data', 'reporta_a','fullname']) ? modalCreate.getIn(['data', 'reporta_a','fullname']) : '' } onClick={ () => this.handleOpenSelectorReportaA(`modalCreate.data.reporta_a`) } onReset={ () => this.props.updateInputsInModalCreate(`reporta_a`, null) } />
											</div>
										</div>
									</div>
								</div>
								<div className="col-md-9" style={{ height: '100%'}}>
									<div className="row" style={{ height: '100%', overflowX: 'hidden' }}>
										<div className="col-md-12" style={{ height: '100%' }}>
											<div className="nav-container">
												<div className="nav-tabs-section">
													<ul className="nav-tabs-tabs green">
														{
															tabs.map(x => {
																return (
																	<li key={ `li02[${x.id}]` } className={ selected === x.id ? 'active' : '' }>
																		<a onClick={ (e) => this.selectTab(e, x.id) }>{ x.caption }</a>
																	</li>
																)
															})
														}
													</ul>
												</div>
												<div className="nav-main-section">
													<div className="nav-main-section-scrollable">
														{ tabs[selected].component }
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</ModalBody >
					<ModalFooter >
					</ModalFooter>
				</form>
			</Modal>
		)
	}
}

const mapStateToProps = (state, onwProps) => {
	return {
		modalCreate: state.usuarios.get('modalCreate'),
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		displayModalCreate: (show, title, mode) => dispatch(displayModalCreate(show, title, mode)),
		updateInputsInModalCreate: (attr, value) => dispatch(updateInputsInModalCreate(attr, value)),
		createOrUpdateUsuarios: (data, mode) => dispatch(createOrUpdateUsuarios(data, mode)),
        showModalSelector: (title, fields, url, action, customFilter) => dispatch(showModalSelector(title, fields, url, action, customFilter)),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreate)



// WEBPACK FOOTER //
// ./src/components/Usuarios/ModalCreate.jsx